import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { makeStyles, Typography, Button, Divider } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";

// Configuração do Worker do PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const useStyles = makeStyles((theme) => ({
  pdfContainer: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: 250,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  thumbnail: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
    overflow: "hidden",
    borderRadius: 4,
    height: 150,
    "& canvas": {
      width: "100% !important",
      height: "auto !important",
    },
  },
  pdfInfo: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  fileName: {
    fontSize: "0.85rem",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  downloadButton: {
    marginTop: theme.spacing(1),
  },
}));

const PdfPreview = ({ url, body }) => {
  const classes = useStyles();
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleClick = () => {
    window.open(url, "_blank");
  };

  // Extrair nome do arquivo da URL se o body for igual ao path.basename
  const fileName = body || url.split("/").pop();

  return (
    <div className={classes.pdfContainer} onClick={handleClick}>
      <div className={classes.thumbnail}>
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Typography variant="caption">Carregando preview...</Typography>}
          error={<Typography variant="caption" color="error">Erro no preview</Typography>}
        >
          <Page pageNumber={1} width={200} renderTextLayer={false} renderAnnotationLayer={false} />
        </Document>
      </div>
      <div className={classes.pdfInfo}>
        <Typography className={classes.fileName} variant="body2">
          {fileName}
        </Typography>
        <Divider />
        <Button
          size="small"
          startIcon={<GetApp />}
          variant="text"
          fullWidth
          className={classes.downloadButton}
        >
          Visualizar
        </Button>
      </div>
    </div>
  );
};

export default PdfPreview;
